module.exports = __webpack_public_path__ + "static/media/heat-ball-3.545062af.gif";